export default __webpack_public_path__ + "static/media/francheville02.04cbc0a3.jpg";